import { c as _c } from "react/compiler-runtime";
import type { AgentGraphOutputs, OrgArtifact } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import type { ArtifactSelectorOptionId } from '../header/types';
import { ArtifactRow, Section } from './artifact-list';

// The run resolves `outputs.artifactKey` into this flag when the artifact is written, falling back
// to the graph's per-artifact star for agents authored before the pointer existed.
export const isFinalArtifact = (artifact: OrgArtifact) => artifact.metadata.kind === 'agent_graph_artifact' && artifact.metadata.data.isStarred;

// `judgmentKey` names a key in the graph's shared output namespace, so the designated decision is
// emitted by a task (a judgment), a rules node (a rule result), or a decision node.
const isFinalDecision = (artifact: OrgArtifact, judgmentKey?: string) => !!judgmentKey && (artifact.metadata.kind === 'agent_graph_judgement' || artifact.metadata.kind === 'agent_graph_rule_result' || artifact.metadata.kind === 'agent_graph_decision_result') && artifact.metadata.data.fieldKey === judgmentKey;
type FinalOutputProps = {
  artifacts: OrgArtifact[];
  outputs?: AgentGraphOutputs;
  selectedOptionId: ArtifactSelectorOptionId;
  onSelect: (optionId: ArtifactSelectorOptionId) => void;
  /** Empty when the viewer lacks `manual_review`, so a row can render with no value tag. */
  judgmentValues?: Record<string, string>;
};
const FinalOutput = t0 => {
  const $ = _c(23);
  const {
    artifacts,
    outputs,
    selectedOptionId,
    onSelect,
    judgmentValues
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "artifactSidebar.finalOutput"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("artifact", t1);
  let t2;
  if ($[1] !== artifacts || $[2] !== outputs?.judgmentKey) {
    let t3;
    if ($[4] !== outputs?.judgmentKey) {
      t3 = a => isFinalDecision(a, outputs?.judgmentKey);
      $[4] = outputs?.judgmentKey;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    t2 = artifacts.find(t3);
    $[1] = artifacts;
    $[2] = outputs?.judgmentKey;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const decision = t2;
  let t3;
  if ($[6] !== artifacts) {
    t3 = artifacts.find(isFinalArtifact);
    $[6] = artifacts;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const artifact = t3;
  if (!decision && !artifact) {
    return null;
  }
  let t4;
  if ($[8] !== t) {
    t4 = t(_temp);
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== decision || $[11] !== judgmentValues || $[12] !== onSelect || $[13] !== selectedOptionId) {
    t5 = decision && <ArtifactRow artifact={decision} selectedOptionId={selectedOptionId} onSelect={onSelect} value={judgmentValues?.[decision.id]} />;
    $[10] = decision;
    $[11] = judgmentValues;
    $[12] = onSelect;
    $[13] = selectedOptionId;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== artifact || $[16] !== onSelect || $[17] !== selectedOptionId) {
    t6 = artifact && <ArtifactRow artifact={artifact} selectedOptionId={selectedOptionId} onSelect={onSelect} />;
    $[15] = artifact;
    $[16] = onSelect;
    $[17] = selectedOptionId;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t4 || $[20] !== t5 || $[21] !== t6) {
    t7 = <Section title={t4}>{t5}{t6}</Section>;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
};
export default FinalOutput;
function _temp($) {
  return $.title;
}